import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class UpdateDressCodeErrorAction implements Action {
  public static readonly type = 'UpdateDressCodeErrorAction';

  constructor(public error: BijbError) {
  }

  public type = UpdateDressCodeErrorAction.type;
}
